import React from 'react';
import { FB, FBAutocompleteAsyncOption, FBAutocompleteAsyncState } from '..';
import FBAutocompleteAsyncStore from '../FBAutocompleteAsync/FBAutocompleteAsync.store';
import { useObserver } from 'mobx-react';
import { SerialNumber } from '../FBSerials/types';

export const useSerialNumbersOptions = (id: string) => {
  const baseOptionId = FBAutocompleteAsyncOption.LHRSerial;
  // Create a unique key by combining optionId with id to avoid conflicts
  const uniqueOptionId = id ? `${baseOptionId}_${id}` : baseOptionId;
  const autocompleteAsyncState = FB.useRef<FBAutocompleteAsyncState>(FBAutocompleteAsyncState, { optionId: baseOptionId });

  React.useEffect(() => {
    if (!id) {
      return;
    }

    const existingData = FBAutocompleteAsyncStore.data.get(uniqueOptionId);
    if (existingData && existingData.size > 0) {
      return;
    }

    autocompleteAsyncState.setOptionId(baseOptionId);
    autocompleteAsyncState.fetchAutocompleteOption(id, baseOptionId);
  }, [autocompleteAsyncState, id, baseOptionId, uniqueOptionId]);

  return useObserver(() => {
    if (!id) {
      return {
        serialNumbersOptions: [],
      };
    }

    let asyncData = FBAutocompleteAsyncStore.data.get(uniqueOptionId) as Map<string, SerialNumber>;

    if (!asyncData || asyncData.size === 0) {
      const apiData = autocompleteAsyncState.autocompleteValueApi.data;

      if (apiData) {
        const preparedData = Array.isArray(apiData) ? apiData : [apiData];

        if (preparedData.length > 0) {
          FBAutocompleteAsyncStore.setOptionData(uniqueOptionId, preparedData);
          asyncData = FBAutocompleteAsyncStore.data.get(uniqueOptionId) as Map<string, SerialNumber>;
        } else {
          FBAutocompleteAsyncStore.setOptionData(uniqueOptionId, []);
        }
      }
    }

    const serialNumbersOptions = Array.from(asyncData?.values() ?? []) ?? [];
    return { serialNumbersOptions };
  });
};
